import isString from 'lodash/isString'

let urlParams

const updateUrlParams = () => {
  // Replace addition symbol with a space and then decode
  const decode = (string) => decodeURIComponent(string.replace(/\+/g, ' '))
  const search = /([^&=]+)=?([^&]*)/g
  const query = window.location.search.substring(1)

  let match = search.exec(query)
  urlParams = {}
  while (match) {
    urlParams[decode(match[1])] = decode(match[2])
    match = search.exec(query)
  }
}

export const getUrlParam = (name) => {
  updateUrlParams()
  return urlParams[name]
}

export const hasUrlParam = (name) => isString(getUrlParam(name))

/**
 * Parses path patterns and creates a URL string containing input path variables.
 * eg: toPath('/event/:eventId/order/:orderId, {eventId: 123, orderId: 456}) => '/event/123/order/456'
 *
 * @param pathPattern {string} URL string pattern containing path variables
 * @param pathVariables {object} Object of path variable keys and their respective values
 * @param pathVariablePrefix {string} String prefix to denote a path variable
 * @returns {string} Constructed path URL based on input path variables
 */
export const toPath = (pathPattern, pathVariables, pathVariablePrefix = ':') =>
  pathPattern
    .split('/')
    .map((token) => {
      if (!token.includes(pathVariablePrefix)) {
        return token
      }

      const pathVariableValue = pathVariables[token.replace(pathVariablePrefix, '')]
      if (pathVariableValue) {
        return pathVariableValue
      }

      throw new Error(
        `Missing path variable value for ${token}. Ensure that a value is defined for this variable.`,
      )
    })
    .join('/')

/**
 * Using regex to detect if the parameter contains characters other than alphanumerics,
 * underscores, dashes, or forward slashes with the assumption that all of our own,
 * internal URL's only contain these characters.
 * It weeds out javascript: URL's, external URL's with http: or https:,
 * and other domain name URL's like www.google.com.
 *
 * @param {String} param URL string containing path variables
 * @returns {Boolean} Returns true if the param is valid
 */

export const isValidNextParam = (param) => {
  const invalidParamRegex = /[^\w-/]/gi
  const hasInvalidParam = invalidParamRegex.test(param)

  return typeof param === 'string' && !hasInvalidParam
}
